/* eslint-disable */
import { StyleSheet } from 'react-native'
import { ApplicationStyles } from '../../Themes/'
import { ifIPhoneX } from '../../Lib/utils'
import Fonts from '../../Themes/Fonts'
export default StyleSheet.create({
  ...ApplicationStyles.screen,
  container: {
    flex: 1,
    backgroundColor: 'black',

  },

  marquee: {
    flex: 1,
    position: 'relative',
  },

  header: {
    alignItems: 'center',
    height: '50%',
    position: 'absolute',
    justifyContent: 'center',
    width: '100%',
  },
  gradient: {
    position: 'absolute',
  },
  payoffText: {
    color: 'white',
    backgroundColor: 'transparent',
    fontFamily: Fonts.style.font.light,
    fontSize: 16,
    lineHeight: 22,
    marginTop: 20,
    marginLeft: 38,
    marginRight: 38,
    textAlign: 'center',

  },

  footer: {
    alignItems: 'center',
    bottom: 0,
    position: 'absolute',
    padding: 20,
    justifyContent: 'flex-end',
    width: '100%',
    ...ifIPhoneX(
      {
        paddingBottom: 20 + 34,
      },
      null
    ),
  },

  button: {
    borderRadius: 5,
    height: 57,
    justifyContent: 'center',
    width: '100%',
  },

  buttonText: {
    color: 'white',
    fontFamily: Fonts.style.font.regular,
    fontSize: 16,
    textAlign: 'center',
  },

  fbButton: {
    alignItems: 'center',
    backgroundColor: '#3B5997',
    margin: 7,
  },

  fbButtonIcon: {
    left: '5%',
    position: 'absolute',
  },

  registerButton: {
    backgroundColor: '#1A1A1A',
    marginBottom: 18,
  },

  signInLink: {
    fontFamily: Fonts.style.font.bold,
    textDecorationLine: 'underline',
    color : "white"
  },

  signInText: {
    color: 'white',
    fontFamily: Fonts.style.font.regular,
    fontSize: 14,
  },
  marginBottom:   {
    marginBottom : 10
  }

})
